import React, { useMemo } from "react";
import { useNodeAndLinks } from "../../hooks";
import { getOpacity } from "../../formatters";
import PropTypes from 'prop-types';

const propTypes = {
  colors: PropTypes.func,
  node: PropTypes.any,
  sankeyWidth: PropTypes.number,
  sankeyHeight: PropTypes.number,
  reorganizeGraph: PropTypes.bool,
  columnWidth: PropTypes.number,
}

const Node = ({ colors, node, sankeyWidth, sankeyHeight, reorganizeGraph, columnWidth }) => {
  const { handleMouseEnter, handleMouseMove, handleMouseLeave, opacities, currentActives } = useNodeAndLinks();
  const opacity = useMemo(() => getOpacity(node, currentActives, opacities), [currentActives]);
  const color = colors(node);
  const strokeLength = 10;
  return (
    <rect
      rx={3}
      ry={3}
      x={reorganizeGraph && node.page === 0 ? node.x0 + columnWidth + strokeLength : node.x0}
      y={node.y0 - 2}
      width={node.x1 - node.x0}
      height={node.y1 - node.y0 + 4}
      stroke={color}
      fill={color}
      fillOpacity={opacity}
      onMouseEnter={event => handleMouseEnter(event, node, sankeyWidth, sankeyHeight)}
      onMouseMove={event => handleMouseMove(event, node, sankeyWidth, sankeyHeight)}
      onMouseLeave={handleMouseLeave}
    />
  );
};

Node.propTypes = propTypes
Node.defaultProps = {}

export default Node;